import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, InputAdornment } from '@mui/material';
import PaginacionControl from '../components/PaginacionControl';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { GridOn } from '@mui/icons-material';
import axios from 'axios';

const API_URL = '/api/subcategorias';
const API_CATEGORIAS = '/api/categorias';

const Subcategorias = () => {
    // Exportar Excel
    const exportExcel = () => {
      (async () => {
        const { exportGenericWorkbook } = await import('../utils/excel/genericWorkbook');
        const filtered = subcategorias.filter(sub =>
          sub.nombre.toLowerCase().includes(searchValue.toLowerCase()) ||
          sub.categoria_nombre.toLowerCase().includes(searchValue.toLowerCase())
        );
        const rows = (rowsPerPage === -1 ? filtered : filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))
          .map(sub => ({ id: sub.id, nombre: sub.nombre, categoria: sub.categoria_nombre }));
        await exportGenericWorkbook({
          titulo: 'REPORTE - SUBCATEGORÍAS',
          sheetName: 'Subcategorias',
          tableName: 'tblSubcategorias',
          fileName: 'Subcategorias',
          columns: [
            { key: 'id', label: 'ID', width: 8 },
            { key: 'nombre', label: 'Nombre', width: 26 },
            { key: 'categoria', label: 'Categoría', width: 26 }
          ],
          rows,
          searchText: searchValue,
          usuario: ''
        });
      })();
    };
  const [subcategorias, setSubcategorias] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [open, setOpen] = useState(false);
  const [nombre, setNombre] = useState('');
  const [categoriaId, setCategoriaId] = useState('');
  const [editId, setEditId] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);

  const fetchSubcategorias = async () => {
    const res = await axios.get(API_URL);
    setSubcategorias(res.data);
  };
  const fetchCategorias = async () => {
    const res = await axios.get(API_CATEGORIAS);
    setCategorias(Array.isArray(res.data) ? res.data : []);
  };

  useEffect(() => {
    fetchSubcategorias();
    fetchCategorias();
  }, []);

  const handleOpen = (sub = null) => {
    if (sub) {
      setEditId(sub.id);
      setNombre(sub.nombre);
      setCategoriaId(sub.categoria_id);
    } else {
      setEditId(null);
      setNombre('');
      setCategoriaId('');
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setNombre('');
    setCategoriaId('');
    setEditId(null);
  };

  const handleSave = async () => {
    try {
      if (editId) {
        await axios.put(`${API_URL}/${editId}`, { nombre, categoria_id: categoriaId });
      } else {
        await axios.post(API_URL, { nombre, categoria_id: categoriaId });
      }
      fetchSubcategorias();
      handleClose();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al guardar');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Eliminar esta subcategoría?')) {
      try {
        await axios.delete(`${API_URL}/${id}`);
        fetchSubcategorias();
      } catch { alert('Error al eliminar'); }
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800, mt: { xs: '0em', sm: '0em', md: '0em' } }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3, fontWeight: 'bold', color: '#222' }}>Subcategorías</Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField
            placeholder="Buscar..."
            value={searchValue}
            onChange={e => { setSearchValue(e.target.value); setPage(0); }}
            size="small"
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }}
            sx={{ flex: 1 }}
          />
          <Button variant="contained" color="success" startIcon={<GridOn />} onClick={exportExcel} sx={{ minWidth: 120 }}>
            Exportar Excel
          </Button>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()} sx={{ ml: { xs: 0, sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>Nueva Subcategoría</Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPage}
            onChange={e => { setRowsPerPage(Number(e.target.value)); setPage(0); }}
            sx={{ width: 100 }}
          />
        </Box>
      <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', mt: 2, overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ pr: 8 }}>ID</TableCell>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Categoría</TableCell>
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {subcategorias
              .filter(sub => sub.nombre.toLowerCase().includes(searchValue.toLowerCase()) || sub.categoria_nombre.toLowerCase().includes(searchValue.toLowerCase()))
              .slice(rowsPerPage === -1 ? 0 : page * rowsPerPage, rowsPerPage === -1 ? undefined : (page + 1) * rowsPerPage)
              .map((sub) => (
                <TableRow key={sub.id}>
                  <TableCell align="center" sx={{ pr: 8 }}>{sub.id}</TableCell>
                  <TableCell align="center">{sub.nombre}</TableCell>
                  <TableCell align="center">{sub.categoria_nombre}</TableCell>
                  <TableCell align="center">
                    <IconButton color="primary" onClick={() => handleOpen(sub)}><EditIcon /></IconButton>
                    <IconButton color="error" onClick={() => handleDelete(sub.id)}><DeleteIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginacionControl
        page={page}
        rowsPerPage={rowsPerPage}
        count={subcategorias.filter(sub => sub.nombre.toLowerCase().includes(searchValue.toLowerCase()) || sub.categoria_nombre.toLowerCase().includes(searchValue.toLowerCase())).length}
        onPageChange={setPage}
      />
      <Dialog open={open} onClose={(_, r) => r !== 'backdropClick' && handleClose()} disableEscapeKeyDown={false} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h5" fontWeight="bold">
            {editId ? 'Editar Subcategoría' : 'Nueva Subcategoría'}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Nombre"
            value={nombre}
            onChange={e => setNombre(e.target.value)}
            fullWidth
            margin="dense"
          />
          <Autocomplete
            options={categorias}
            getOptionLabel={option => option.nombre || ''}
            value={categorias.find(cat => cat.id === categoriaId) || null}
            onChange={(_, newValue) => setCategoriaId(newValue ? newValue.id : '')}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={params => (
              <TextField {...params} label="Categoría" margin="dense" fullWidth />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} startIcon={<CloseIcon />} color="error" variant="contained">Cancelar</Button>
          <Button onClick={handleSave} variant="contained" startIcon={<SaveIcon />} color="primary">Guardar</Button>
        </DialogActions>
      </Dialog>
    </Box>
    </Box>
  );
};

export default Subcategorias;
